import { Users } from '@phosphor-icons/react';

export default Users;
